<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SpSUZ/tc-custom/9781452121260.jpg?1718106413562" alt="This image is the cover for the book K is for Knifeball"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">K is for Knifeball
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An adult parody of children’s alphabet books, offering horrible—but hilarious—advice, from the authors of <i>All my friends are dead.</i></b><br/><br/> In the humorous vein of <i>Go the F**k to Sleep</i> comes a laugh-out-loud collection of bad advice that turns the children’s alphabet book on its head. Adorable, illustrated characters lead readers down a path of poor decision-making, and alphabetical, rhyming couplets offer terrible life lessons. O is for opening things with your teeth, F is for setting Daddy’s wallet on fire, and R is for Raccoon (but definitely not for rabies).<br/><br/> With plenty of playfully disastrous choices lurking around every corner, this compendium of black humor may be terrible for actual children, but it’s perfect for the common-senseless child in all adults. Plus, this is the fixed-format version, which looks nearly identical to the physical book.<br/><br/><b>Praise for <i>K is for Knifeball</i></b><br/><br/> “Great fun for adults. The humorous illustrations, done in the style common in kids books, greatly add to the fun.” —Geek Alerts</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Avery Monsen, Jory John
      </h2>
      
      <p class="authorDescription body article">Avery Monsen is a New York–based artist and writer. He is the co-author of All my friends are dead. and All my friends are still dead.Jory John is a California-based writer, editor, and cartoonist. He is the co-author of All my friends are dead. and All my friends are still dead.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f4e9185